import { render, staticRenderFns } from "./LiquidationComission.vue?vue&type=template&id=23f44caf&scoped=true"
import script from "./LiquidationComission.vue?vue&type=script&lang=js"
export * from "./LiquidationComission.vue?vue&type=script&lang=js"
import style0 from "./LiquidationComission.vue?vue&type=style&index=0&id=23f44caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f44caf",
  null
  
)

export default component.exports